import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {MaterialModules} from '../app.material';
import {NumberOnlyDirective} from '../directives/numberOnly.directive';
import { DynamicFormComponent } from './dynamicform/dynamicform.component';
import { DynamicInputComponent } from './dynamicform/dynamicinput.component/dynamicinput.component';



@NgModule({
    declarations: [
        NumberOnlyDirective,
        DynamicFormComponent,
        DynamicInputComponent,
    ],
    exports:[
        NumberOnlyDirective,
        DynamicFormComponent,
        DynamicInputComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModules
    ],
    providers: [
    ],
  })
  export class CoreMondules { }